module.exports = __webpack_public_path__ + "img/to_shop_tc.d893c463.png";